import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createWarehouse } from "../../api/apiInventory";
import parseError from "../../utils/parseError";

export const useCreateWarehouse = () => {
    const queryClient = useQueryClient();
    const { mutate: createWarehouseMutate, isPending: isCreating } = useMutation({
        mutationFn: createWarehouse,
        onSuccess: (res) => {
            toast.success(res.message || "Warehouse created");
            queryClient.invalidateQueries(["warehouses"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to create warehouse"),
    });
    return { createWarehouseMutate, isCreating };
};
